<template>
    <div class="document-container">
        <!-- 登录系统 -->
        <div class="login-container">
            <h2>进入系统</h2>
            <p>登录后点击用户头像进入用户工作台，可查看积分余额、功能模块入口与使用记录。</p>

            <div class="imageInfo">
                <img src="@/assets/userBook/image22.png" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LoginAccount',
    data() {
        return {
        }
    },

}
</script>

<style lang="scss" scoped>
.document-container {
    max-width: 1000px;
    margin: 0 auto;
    // padding: 20px;
    font-family: "Microsoft YaHei", sans-serif;
    color: #000;
    line-height: 1.6;
}

.imageInfo {
    width: 800px;
    box-shadow: 0px 1px 20px #eeeeee;
    margin: 50px 0px;

    img {
        width: 100%;
    }
}
</style>